import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContentUserinfo from '../../views/settings/Tab.userinfo';
import TabContentAdmin from '../../views/settings/Tab.admin';
import TabContentSeller from '../../views/settings/Tab.seller';
import './tabs.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function Tabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <TabContext value={value}>
        <AppBar color="transparent" elevation={0} position="static">
          <TabList onChange={handleChange} aria-label="simple tabs example">
            <Tab label="Mijn gegevens" value="1" />
            <Tab label="Admins" value="2" />
            <Tab label="Verkopers" value="3" />
          </TabList>
        </AppBar>
        <TabPanel value="1">
          <TabContentUserinfo />
        </TabPanel>
        <TabPanel value="2">
          <TabContentAdmin />
        </TabPanel>
        <TabPanel value="3">
          <TabContentSeller />
        </TabPanel>
      </TabContext>
    </div>
  );
}
